import React from "react"

const TitleText = props => {
  return (
    <div className="title-text">
      <h1>{props.titleText}</h1>
    </div>
  )
}

export default TitleText
